const TENOR_API_KEY = process.env.REACT_APP_TENOR_API_KEY || 'demo_api_key';
const TENOR_BASE_URL = 'https://tenor.googleapis.com/v2';
const CLIENT_KEY = 'giveittonextperson_app';

class TenorService {
  async searchGifs(query, limit = 20, pos = 0) {
    try {
      const response = await fetch(
        `${TENOR_BASE_URL}/search?key=${TENOR_API_KEY}&client_key=${CLIENT_KEY}&q=${encodeURIComponent(query)}&limit=${limit}&pos=${pos}&contentfilter=medium&media_filter=gif`
      );
      
      if (!response.ok) {
        throw new Error(`Tenor API error: ${response.status}`);
      }
      
      const data = await response.json();
      return this.formatGifs(data.results || []);
    } catch (error) {
      console.error('Error searching GIFs:', error);
      return [];
    }
  }

  async getFeaturedGifs(limit = 20, pos = 0) {
    try {
      const response = await fetch(
        `${TENOR_BASE_URL}/featured?key=${TENOR_API_KEY}&client_key=${CLIENT_KEY}&limit=${limit}&pos=${pos}&contentfilter=medium&media_filter=gif`
      );
      
      if (!response.ok) {
        throw new Error(`Tenor API error: ${response.status}`);
      }
      
      const data = await response.json();
      return this.formatGifs(data.results || []);
    } catch (error) {
      console.error('Error fetching featured GIFs:', error);
      return [];
    }
  }

  formatGifs(gifs) {
    return gifs.map(gif => {
      const gifFormat = gif.media_formats?.gif || {};
      const previewFormat = gif.media_formats?.tinygif || gif.media_formats?.nanogif || gifFormat;
      const thumbnailFormat = gif.media_formats?.tinygif || gif.media_formats?.nanogif || gifFormat;
      
      return {
        id: gif.id,
        title: gif.content_description || 'GIF',
        url: gifFormat.url || '',
        preview: previewFormat.url || gifFormat.url || '',
        thumbnail: thumbnailFormat.url || gifFormat.url || '',
        width: gifFormat.dims?.[0] || 300,
        height: gifFormat.dims?.[1] || 300
      };
    }).filter(gif => gif.url); // Filter out GIFs without URLs
  }
}

const tenorService = new TenorService();
export default tenorService;